import { useState } from "react";

export default function BrandForm({ onSubmit }) {
  const [form, setForm] = useState({ name: "", description: "" });
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await onSubmit(form);
    } catch (err) {
      setError(err.message || "Fout bij aanmaken merk");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && <p className="text-red-600">{error}</p>}

      <div>
        <label className="block font-medium mb-1">Naam</label>
        <input
          name="name"
          className="border rounded p-2 w-full"
          value={form.name}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label className="block font-medium mb-1">Omschrijving</label>
        <textarea
          name="description"
          className="border rounded p-2 w-full"
          value={form.description}
          onChange={handleChange}
          rows="3"
        />
      </div>

      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
      >
        Opslaan
      </button>
    </form>
  );
}
